module.exports = __webpack_public_path__ + "img/player-configuration.33064953.jpg";